export const getErrorType = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors: any[],
  isViewer = false,
): "NONE" | "NOT_FOUND" | "UNKNOWN" | "SHOULD_PURCHASE" => {
  if (errors.every((v) => v === undefined)) {
    return "NONE"
  }

  if (errors.filter((v) => !!v).every((v) => v?.response?.status === 404)) {
    return "NOT_FOUND"
  }

  if (
    isViewer &&
    errors.filter((v) => !!v).every((v) => v?.response?.status === 402)
  ) {
    return "SHOULD_PURCHASE"
  }

  return "UNKNOWN"
}
